import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { combineLatest } from 'rxjs';
import { User } from 'src/app/interfaces/user';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {
  /**
   * Has all userdata been loaded
   */
  finishedLoadingUsers: boolean = false;
  /**
   * noteForm
   */
  noteForm: UntypedFormGroup;
  /**
   * activeServicesForm
   */
  activeServicesForm: FormGroup;
  /**
   * lockedServicesForm
   */
  lockedServicesForm: FormGroup;
  /**
   * legalForm
   */
  legalForm: FormGroup;
  /**
   * THe currently selected User as Object
   */
  currentUser: User = null;
  /**
   * The Array of services as Checkboxes
   */
  serviceCheckboxOptions: Array<any> = []
  /**
   * Has the user agreed to the data_processing_state (Newsletter)
   */
  data_processing_state = null;
  /**
   * Has the user agreed to the participation
   */
  agreed_participation = null;
  /**
   * 
   */
  lockedService_Event = null;
  /**
   * Has the user agreed to the privacy
   */
  agreed_privacy = null;
  /**
   * The active services of the user
   */
  services: Array<any> = [];
  /**
   * constructor
   * Init the Forms
   * @param fb 
   * @param route 
   * @param businessuserService 
   * @param overlayService 
   */
  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private businessuserService: BusinessuserService,
    private overlayService: OverlayService) {

    this.noteForm = this.fb.group({
      note: ['', [Validators.required]]
    });

    this.activeServicesForm = this.fb.group({
      services: this.fb.array([])
    });

    this.lockedServicesForm = this.fb.group({
      vtw: [{ value: false, disabled: true }]
    });

    this.legalForm = this.fb.group({
      data_processing_state: [false],
      agreed_participation: [false],
      agreed_privacy: [false],
    });
  }
  /**
   * ngOnInit
   * 
   * getBuissnessUser
   * getAccountNote
   * getAccountOptionsForAccount
   * getUserProperties
   */
  ngOnInit(): void {
    this.reloadData();
  }
  /**
   * Edit the note of the user 
   * @returns 
   */
  editAccountNote() {
    this.noteForm.markAllAsTouched();
    if (this.noteForm.invalid) {
      return;
    }
    this.businessuserService.editAccountNote(this.currentUser.publicId, this.noteForm.getRawValue().note).subscribe(() => {
      this.overlayService.openSnackBar("Notizen erfolgreich geändert!")
    });
  }

  /**
   * save Userproperties based on the property passed in
   * @param property 
   */
  saveProperties(property) {
    switch (property) {
      case "data_processing_state":
        if (this.data_processing_state == null) {
          let date = new Date().toISOString();
          this.data_processing_state = {
            "lastModified": date,
            "name": "data.processing.state",
            "value": this.legalForm.getRawValue().data_processing_state == true ? "validated" : "rejected",
            "valueType": "java.lang.Boolean",
          }
          this.businessuserService.editUserProperties(this.currentUser.publicId, this.data_processing_state).subscribe(() => {
            this.overlayService.openSnackBar("Datenschutzeinstellungen erfolgreich geändert!");
            this.reloadData();
          });
        } else {
          this.data_processing_state.lastModified = new Date().toISOString();
          if (this.legalForm.getRawValue().data_processing_state == true) {
            this.data_processing_state.value = "validated"
          } else {
            this.data_processing_state.value = "rejected"
          }
          this.businessuserService.editUserProperties(this.currentUser.publicId, this.data_processing_state).subscribe(() => {
            this.overlayService.openSnackBar("Datenschutzeinstellungen erfolgreich geändert!");
            this.reloadData();
          });
        }

        break;
      case "agreed_participation":
        if (this.agreed_participation == null) {
          let temp = {
            "created": new Date().toISOString(),
            "lastModified": new Date().toISOString(),
            "links": [],
            "name": "agreed_participation",
            "value": String(true),
            "valueType": "java.lang.Boolean"
          }
          this.businessuserService.editUserProperties(this.currentUser.publicId, temp).subscribe(() => {
            this.overlayService.openSnackBar("Teilnahmebedingungen erfolgreich geändert!");
            this.reloadData();
          });
        } else {
          this.agreed_participation.lastModified = new Date().toISOString();
          this.agreed_participation.value = String(this.legalForm.getRawValue().agreed_participation)
          this.businessuserService.editUserProperties(this.currentUser.publicId, this.agreed_participation).subscribe(() => {
            this.overlayService.openSnackBar("Teilnahmebedingungen erfolgreich geändert!");
            this.reloadData();
          });
        }
        break;
      case "agreed_privacy":
        if (this.agreed_privacy == null) {
          this.agreed_privacy = {
            "created": new Date().toISOString(),
            "lastModified": new Date().toISOString(),
            "links": [],
            "name": "agreed_privacy",
            "value": String(true),
            "valueType": "java.lang.Boolean"
          }
          this.businessuserService.editUserProperties(this.currentUser.publicId, this.agreed_privacy).subscribe(() => {
            this.overlayService.openSnackBar("Datenschutzeinstellungen erfolgreich geändert!");
            this.reloadData();
          });
        } else {
          this.agreed_privacy.lastModified = new Date().toISOString();
          this.agreed_privacy.value = String(this.legalForm.getRawValue().agreed_privacy)
          this.businessuserService.editUserProperties(this.currentUser.publicId, this.agreed_privacy).subscribe(() => {
            this.overlayService.openSnackBar("Datenschutzeinstellungen erfolgreich geändert!");
            this.reloadData();
          });
          break;
        }
      }
    }
    /**
     * Activate a userservice (AccountOptions)
     * @param servive 
     */
    activateService(servive) {
      this.services.forEach(element => {
        if (element.accountOption.id == servive.accountOption.id) {
          servive.state = !servive.state;
        }
      });
      this.businessuserService.editAccountOptionsForAccount(this.currentUser.publicId, this.services).subscribe(() => {
        this.overlayService.openSnackBar("Zusatzfunktionen erfolgreich geändert!")
      })
    }

    reloadData(){
      this.route.params.subscribe(params => {
        combineLatest([
          this.businessuserService.getBuissnessUser(params['id']),
          this.businessuserService.getAccountNote(params['id']),
          this.businessuserService.getAccountOptionsForAccount(params['id']),
          this.businessuserService.getUserProperties(params['id']),
        ]).subscribe(([user, note, options, properties]: [User, any, any, any]) => {
          this.currentUser = user;
          this.services = options;
          options.content.forEach(element => {
            if (element.accountOption.state === "ACTIVE") {
              this.serviceCheckboxOptions.push({
                name: element.accountOption.displayName, value: element.accountOption.id, checked: element.state, obj: element
              })
            }
          });
          if (note != null) {
            this.noteForm.patchValue({
              note: note
            })
          }
  
          properties.forEach(prop => {
            if (prop.name == 'data.processing.state') {
              this.data_processing_state = prop;
              if (prop.value == "validated") {
                this.legalForm.patchValue({
                  data_processing_state: true
                })
              } else if (prop.value == "true") {
                this.legalForm.patchValue({
                  data_processing_state: true
                })
              } else if (prop.value == "rejected") {
                this.legalForm.patchValue({
                  data_processing_state: false
                })
              } else if (prop.value == "false") {
                this.legalForm.patchValue({
                  data_processing_state: false
                })
              }
            } else if (prop.name == 'agreed_participation') {
              this.agreed_participation = prop;
              this.legalForm.patchValue({
                agreed_participation: JSON.parse(prop.value)
              })
            } else if (prop.name == 'agreed_privacy') {
              this.agreed_privacy = prop;
              this.legalForm.patchValue({
                agreed_privacy: JSON.parse(prop.value)
              })
            } else if (prop.name == 'lockedService./event') {
              this.lockedService_Event = prop;
              // this.lockedServicesForm.patchValue({
              //   vtw: JSON.parse(prop.value)
              // })
            }
          });
          this.finishedLoadingUsers = true;
        })
      })
    }
  }
